(function () {
    'use strict';

    // @ngInject
    function OfferLoanModalControllerCtor($scope, $injector, AnalyticsService,
                                          $modalInstance, WorkspaceFilesManager, UsersManager, ModalService,
                                          fileId, fileTitle, projectName, loanAmount, netLoanAmount, loanDueDate, interestFee, moment) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'OfferLoanModalControllerController';
        AnalyticsService.trackPageView(this, 'OfferLoanModalControllerView');

        this.$modalInstance = $modalInstance;
        this.WorkspaceFilesManager = WorkspaceFilesManager;
        this.AnalyticsService = AnalyticsService;
        this.fileId = fileId;
        this.fileTitle = fileTitle;
        this.projectName = projectName;
        this.loanAmount = loanAmount;
        this.netLoanAmount = netLoanAmount;
        this.loanDueDate = loanDueDate;
        this.interestFee = interestFee;
        this.moment = moment;
        this.errorMessage = null;
        this.isApproved = false;
        this.user = UsersManager.getCurrUser();
        this.requestInProgress = false;
        this.ModalService = ModalService;
    }

    Controllers.OfferLoanModalController = Class(Controllers.BaseController, {
        constructor: OfferLoanModalControllerCtor,

        cancel: function cancel() {
            this.$modalInstance.dismiss();
        },

        internal_get_loan: function internal_get_loan() {
            this.WorkspaceFilesManager.getLoan(this.fileId)
                .then(function success() {
                    this.AnalyticsService.trackSuccess(this, 'taking loan succeeded');
                    this.$modalInstance.close('success');
                }.bind(this))
                .catch(function failure(resp) {
                    this.errorMessage = resp.data.error_message;
                    this.AnalyticsService.trackError(this, 'taking loan failed', {file_id: this.fileId, error: this.errorMessage});
                }.bind(this))
                .finally(function final() {
                    this.requestInProgress = false;
                }.bind(this));

        },

        getLoan: function getLoan() {
            if (this.requestInProgress) {
                return;
            }
            //open modal for add bank
            this.requestInProgress = true;
            if (this.user.eligible_for_qwil_loans) {
                if(this.user.qwil_bank_confirm === 'rejected' || this.user.qwil_bank_confirm === 'required' || !this.user.qwil_bank_account_id){
                    var self = this;
                    this.ModalService.openConfirmLoanBankAccountModal().then(function (qwil_bank_account_id) {
                        self.internal_get_loan();
                        self.user.qwil_bank_account_id = qwil_bank_account_id;
                    }).catch(function (resp) {
                        self.requestInProgress = false;
                    });
                } else {
                    this.internal_get_loan();
                }
            }else{
                this.internal_get_loan();
            }
        }
    });
}());
